import React, {useCallback} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {MODE_CREATE, MODE_EDIT} from "../../../codes";
import Editor from "../../../common/Editor";
import useAccountEditor from "./useAccountEditor";
import ColorBox from "../../../common/ColorBox";
import {Checkbox} from "../../../common/Checkbox";
import useProject from "../../../util/useProject";
import {CurrenciesDropdown} from "../../../common/CurrenciesDropdown";

export const AccountEditor = () => {
  const {show, t, mode, hideAccountEditor, editedAccount, submit, updateEditedAccount} = useAccountEditor();
  const {runWithExpiration} = useProject();

  return <Editor
    show={show}
    title={t(mode === MODE_CREATE ? "account_editor_title_add" : "account_editor_title_edit")}
    onShow={useCallback(() => document.getElementById("account-editor-name").focus(), [])}
    onSubmit={runWithExpiration(submit)}
    onCancel={hideAccountEditor}
    submitLabel={t("account_editor_button_save")}
    cancelLabel={t("account_editor_button_cancel")}
  >
    <Form.Group as={Row} className="mb-2" controlId="account-editor-name">
      <Form.Label column sm={3}>{t("account_editor_field_name")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text" value={editedAccount.name}
          onChange={updateEditedAccount("name")}
          maxLength="50"
          isInvalid={editedAccount.errors.name}
        />

        <Form.Control.Feedback type="invalid">{t(editedAccount.errors.name)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="account-editor-description">
      <Form.Label column sm={3}>{t("account_editor_field_description")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedAccount.description}
          onChange={updateEditedAccount("description")}
          maxLength="100"
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="account-editor-currency">
      <Form.Label column sm={3}>{t("account_editor_field_currency")}</Form.Label>
      <Col sm={6}>
        <CurrenciesDropdown
          value={editedAccount.currency}
          onChange={updateEditedAccount("currency")}
          disabled={mode !== MODE_CREATE}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="account-editor-balance">
      <Form.Label column sm={3}>{t("account_editor_field_balance")}</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          value={editedAccount.balance}
          onChange={updateEditedAccount("balance")}
          isInvalid={editedAccount.errors.balance}
        />

        <Form.Control.Feedback type="invalid">{t(editedAccount.errors.balance)}</Form.Control.Feedback>
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-2" controlId="account-editor-color">
      <Form.Label column sm={3}>{t("account_editor_field_color")}</Form.Label>
      <Col sm={9}>
        <ColorBox value={editedAccount.color} onChange={updateEditedAccount("color")}/>
      </Col>
    </Form.Group>

    {mode === MODE_EDIT && <Form.Group as={Row} className="mb-2" controlId="account-editor-active">
        <Form.Label column sm={3}>{t("account_editor_field_active")}</Form.Label>
        <Col sm={9}>
          <Checkbox
            id="account-editor-active"
            checked={editedAccount.active}
            onChange={updateEditedAccount("active")}
          />
        </Col>
      </Form.Group>}
  </Editor>;
};
